exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subButton{margin:10px;font-size:20pt;color:#2c3e50;border-radius:8px;font-family:Avenir,Helvetica,Arial,sans-serif}.sc{font-size:20pt;padding:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-70ff1dbc","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Questions.vue
// module id = 21
// module chunks = 0